export default "__VITE_ASSET__cffe78d0__"